import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HEIGHT_SMOOTH_ANIMATION} from "../../animations";

@Component({
  selector: 'int-expander',
  templateUrl: './int-expander.component.html',
  styleUrls: ['./int-expander.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [HEIGHT_SMOOTH_ANIMATION]
})
export class IntExpanderComponent implements OnInit {

  @Input() isOpen = true;
  @Output() onChange = new EventEmitter<boolean>();

  constructor() { }

  toggle(): void {
    this.isOpen = !this.isOpen;
    this.onChange.emit(this.isOpen);
  }

  ngOnInit(): void {
  }

}
